const MemberLevelIcon = Object.freeze({
  2: 'avatar-pro',
  3: 'avatar-elite'
})

const MemberLevel = Object.freeze({
  Seeker: 1,
  Pro: 2,
  Elite: 3
})

export {
  MemberLevelIcon,
  MemberLevel
}
